<template>
  <div>
    <div class="filter-details">
      <div class="header">
        <span v-if="filterId !== 'new'">
          <span>EDITING FILTER</span>
          <span v-if="filter !== null">"{{ filter.name }}"</span>
        </span>
        <span v-else>CREATE NEW FILTER</span>
      </div>

      <div class="filter-inputs row" v-if="editedFilter !== null">
        <div class="small-12 columns">
          <div class="row">
            <div class="small-6 columns padding-R">   
              <div v-bind:class="{ 'input-field': true, error: formErrors.name }">
                <label>FILTER NAME</label>
                <input type="text" placeholder="Type here." v-model="editedFilter.name" />
                <div class="error-msg">This field is required.</div>
              </div>
            </div>
            <div class="small-3 columns padding-L padding-R">   
              <div v-bind:class="{ 'input-field': true, error: formErrors.beforePickupMins }">
                <label>MINUTES BEFORE PICKUP</label>
                <input type="number" placeholder="Type here." v-model="editedFilter.beforePickupMins" />
                <div class="error-msg">This must be greater than 0.</div>
              </div>
            </div>
            <div class="small-3 columns padding-L">   
              <div v-bind:class="{ 'input-field': true, error: formErrors.afterPickupMins }">
                <label>MINUTES AFTER PICKUP</label>
                <input type="number" placeholder="Type here." v-model="editedFilter.afterPickupMins" />
                <div class="error-msg">This must be greater than 0.</div>
              </div>
            </div>
          </div>

          <div class="row margin-T">
            <div class="small-3 columns padding-R">
              <div v-bind:class="{ 'field-group': true, error: formErrors.tripDirection }">
                <span class="field-group-label">TRIP DIRECTIONS</span>
                <label class="input-checkbox">
                  <input type="checkbox" :value="'all'" v-model="checkedAllTripDirection"/>
                  <span>All</span>
                </label>
                <label class="input-checkbox">
                  <input type="checkbox" :value="'p2p'" v-model="editedFilter.tripDirection"/>
                  <span>Point to Point</span>
                </label>
                <label class="input-checkbox">
                  <input type="checkbox" :value="'in'" v-model="editedFilter.tripDirection"/>
                  <span>In</span>
                </label>
                <label class="input-checkbox">
                  <input type="checkbox" :value="'out'" v-model="editedFilter.tripDirection"/>
                  <span>Out</span>
                </label>
                <div class="error-msg">Please select at least one.</div>
              </div>
            </div>
            <div class="small-9 columns padding-L">
              <div v-bind:class="{ 'field-group': true, error: formErrors.rsvpStatus }">
                <span class="field-group-label">RESERVATION STATUS</span>
                <div class="row">
                  <div class="small-4 columns">
                    <label class="input-checkbox">
                      <input type="checkbox" :value="'all'" v-model="checkedAllRsvpStatus"/>
                      <span>All</span>
                    </label>
                    <label class="input-checkbox">
                      <input type="checkbox" :value="'upcoming'" v-model="editedFilter.rsvpStatus"/>
                      <span>Upcoming</span>
                    </label>
                    <label class="input-checkbox">
                      <input type="checkbox" :value="'auto-dispatch'" v-model="editedFilter.rsvpStatus"/>
                      <span>Auto Dispatch</span>
                    </label>
                    <label class="input-checkbox">
                      <input type="checkbox" :value="'ready'" v-model="editedFilter.rsvpStatus"/>
                      <span>Ready to Go</span>
                    </label>
                    <label class="input-checkbox">
                      <input type="checkbox" :value="'require-dispatch'" v-model="editedFilter.rsvpStatus"/>
                      <span>Requires Dispatch</span>
                    </label>
                  </div>
                  <div class="small-4 columns">
                    <label class="input-checkbox">
                      <input type="checkbox" :value="'driver-response'" v-model="editedFilter.rsvpStatus"/>
                      <span>Pending Driver Response</span>
                    </label>
                    <label class="input-checkbox">
                      <input type="checkbox" :value="'dispatched'" v-model="editedFilter.rsvpStatus"/>
                      <span>Dispatched</span>
                    </label>
                    <label class="input-checkbox">
                      <input type="checkbox" :value="'onboard'" v-model="editedFilter.rsvpStatus"/>
                      <span>On Board</span>
                    </label>
                    <label class="input-checkbox">
                      <input type="checkbox" :value="'completed'" v-model="editedFilter.rsvpStatus"/>
                      <span>Completed</span>
                    </label>
                  </div>
                  <div class="small-4 columns">
                    <label class="input-checkbox">
                      <input type="checkbox" :value="'cancelled'" v-model="editedFilter.rsvpStatus"/>
                      <span>Cancelled</span>
                    </label>
                    <label class="input-checkbox">
                      <input type="checkbox" :value="'packaged'" v-model="editedFilter.rsvpStatus"/>
                      <span>Packaged</span>
                    </label>
                    <label class="input-checkbox">
                      <input type="checkbox" :value="'un-packaged'" v-model="editedFilter.rsvpStatus"/>
                      <span>Unpackaged</span>
                    </label>
                    <label class="input-checkbox">
                      <input type="checkbox" :value="'none'" v-model="editedFilter.rsvpStatus"/>
                      <span>None</span>
                    </label>
                  </div>
                </div>
                <div class="error-msg">Please select at least one.</div>
              </div>
            </div>
          </div>

          <div class="row margin-T">
            <div class="small-3 columns padding-R">
              <div v-bind:class="{ 'field-group': true, error: formErrors.bidSource }">
                <span class="field-group-label">BOOKING SOURCE</span>
                <label class="input-checkbox">
                  <input type="checkbox" :value="'ios'" v-model="editedFilter.bidSource"/>
                  <span>iOS Consumer App</span>
                </label>
                <label class="input-checkbox">
                  <input type="checkbox" :value="'android'" v-model="editedFilter.bidSource"/>
                  <span>Android Consumer App</span>
                </label>
                <label class="input-checkbox">
                  <input type="checkbox" :value="'admin'" v-model="editedFilter.bidSource"/>
                  <span>Backoffice</span>
                </label>
                <label class="input-checkbox">
                  <input type="checkbox" :value="'ww'" v-model="editedFilter.bidSource"/>
                  <span>Website</span>
                </label>
                <label class="input-checkbox">
                  <input type="checkbox" :value="'CSR'" v-model="editedFilter.bidSource"/>
                  <span>CSR</span>
                </label>
                <div class="error-msg">Please select at least one.</div>
              </div>
            </div>

            <!-- <div class="small-4 columns padding-L padding-R">
              <div v-bind:class="{ 'field-group': true, error: formErrors.serviceTypes }">
                <span class="field-group-label">SERVICE TYPES</span>
                <label class="input-checkbox" v-for="service in getServiceTypes()">
                  <input type="checkbox" :value="service.id" v-model="editedFilter.serviceTypes"/>
                  <span>{{ service.name }}</span>
                </label>
                <div class="error-msg">Please select at least one.</div>
              </div>
            </div> -->
            <div class="small-4 columns padding-L padding-R end">
              <div v-bind:class="{ 'field-group': true, error: formErrors.ada }">
                <span class="field-group-label">ADA</span>
                <label class="input-checkbox">
                  <input type="checkbox" :value="'all'" v-model="editedFilter.ada"/>
                  <span>Non ADA</span>
                </label>
                <label class="input-checkbox">
                  <input type="checkbox" :value="'wheelChairLift'" v-model="editedFilter.ada"/>
                  <span>Wheelchair Lift</span>
                </label>
                <label class="input-checkbox">
                  <input type="checkbox" :value="'serviceDog'" v-model="editedFilter.ada"/>
                  <span>Service Dog</span>
                </label>
                <div class="error-msg">Please select at least one.</div>
              </div>
            </div>

            <!--div class="small-4 columns padding-L">
              <span class="field-group-label">RSVP SCREEN DEFAULT PICKUP LOCATION</span>
              <div class="input-address">
                <input type="radio" name="filter-rsvp-default-pickup" :value="'address'" v-model="filter.defaultPickupType"/>
                <div class="autocomplete-input">
                  <input type="text" placeholder="Custom Location" v-model="filter.defaultPickupAddress"
                  v-bind:class="{ disabled: filter.defaultPickupType === 'airport' }"
                  :disabled="filter.defaultPickupType === 'airport'"/>
                </div>
              </div>
              <div class="input-address">
                <input type="radio" name="filter-rsvp-default-pickup" :value="'airport'" v-model="filter.defaultPickupType"/>
                <select v-bind:class="{ disabled: filter.defaultPickupType === 'address' }"
                  :disabled="filter.defaultPickupType === 'address'"
                  v-model="filter.defaultGeofenceId">
                  <option :value="null">Select an Airport</option>
                </select>
              </div>
            </div-->
          </div>

          <div class="row margin-T">
            <div class="small-12 columns padding-R">
              <div v-bind:class="{ 'field-group': true, error: formErrors.serviceTypes }">
                <span class="field-group-label">SERVICE TYPES</span>
                <div class="services">
                  <span class="brand">UNBRANDED</span>
                  <ul class="body">
                    <li v-for="service in getServiceTypes()">
                      <label>
                        <input type="checkbox" :value="service.id" v-model="editedFilter.serviceTypes" />
                        {{ service.name }}
                      </label>
                    </li>
                  </ul>
                </div>
                <div v-for="brand in brands" v-if="serviceList(brand.id).length" class="services">
                  <span class="brand">{{ brand.name }}</span>
                  <ul class="body">
                    <li v-for="service in serviceList(brand.id)">
                      <label>
                        <input type="checkbox" :value="service.id" v-model="editedFilter.serviceTypes" />
                        {{service.label}}
                      </label>
                    </li>
                  </ul>
                </div>
                <div class="error-msg">Please select at least one.</div>
              </div>
            </div>
          </div>

          <div class="row margin-T">
            <div class="small-12 columns">
              <div v-bind:class="{ 'field-group': true, error: formErrors.serviceAreas }">
                <span class="field-group-label">GEOFENCE SERVICE AREAS</span>
                <div class="row servicearea-list">
                  <div class="small-12 columns label">UNBRANDED</div>
                  <div class="small-4 columns end" v-for="serviceArea in unbrandedServicearea()">
                    <label class="input-checkbox">
                      <input type="checkbox" :value="serviceArea.id" v-model="editedFilter.geofenceIds"/>
                      <span>{{ serviceArea.name }}</span>
                    </label>
                  </div>
                </div>
                <div v-for="brand in brands" v-if="serviceList(brand.id).length" class="row servicearea-list">
                  <div class="small-12 columns label">{{ brand.name }}</div>
                  <div class="small-4 columns end" v-for="serviceArea in brandedServicearea(brand.id)">
                    <label class="input-checkbox">
                      <input type="checkbox" :value="serviceArea.id" v-model="editedFilter.geofenceIds"/>
                      <span>{{ serviceArea.name }}</span>
                    </label>
                  </div>
                </div>
                <div class="error-msg">Please select at least one.</div>
              </div>
            </div>
          </div>

          <!--div class="row margin-T">
            <div class="small-12 columns">
              <span class="field-group-label">STAGING LOTS</span>
              <div class="row">
                <div class="small-4 columns" v-for="stagingLot in stagingLots">
                  <label class="input-checkbox">
                    <input type="checkbox" :value="stagingLot.id" v-model="editedFilter.stagingLotIds"/>
                    <span>{{ stagingLot.name }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div-->


          <div class="row margin-T">
            <div class="small-12 columns">
              <div class="controls">
                <a href="#/filters" class="button cta secondary small">GO BACK</a>
                <a href="javscript:;" class="button cta success small" @click="save">SAVE CHANGES</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loading-modal :showModal="fetchingFilter" :modalMessage="'Loading Filter'"></loading-modal>
    <loading-modal :showModal="savingFilter" :modalMessage="'Saving Filter'"></loading-modal>
</div>
</template>

<script>
/* global CONFIG */
import LoadingModal from '../Partials/LoadingModal'
import ApiBrands from '@/modules/api/brands'
import ApiServices from '@/modules/api/services'

export default {
  name: 'filter-details',
  components: { LoadingModal },
  data () {
    return {
      fetchingFilter: false,
      savingFilter: false,
      filter: null,
      editedFilter: null,
      serviceAreas: [],
      stagingLots: [],
      formErrors: {
        name: false,
        beforePickupMins: false,
        afterPickupMins: false,
        tripDirection: false,
        rsvpStatus: false,
        bidSource: false,
        serviceTypes: false,
        ada: false,
        serviceAreas: false,
      },
      brandLoading: false,
      selectedService: []
    }
  },
  computed: {
    filterId () { return this.$route.params.id },
    brands () { return this.$store.state.brands.list },
    checkedAllTripDirection: {
      get () {
        let self = this
        if (self.editedFilter === null) {
          return false
        }
        if (self.editedFilter.tripDirection.length === 4) {
          return true
        }

        let result = []
        for (let i = 0; i < self.editedFilter.tripDirection.length; i++) {
          let item = self.editedFilter.tripDirection[i]
          if (item === 'all') {
            continue
          }
          result.push(item)
        }
        self.editedFilter.tripDirection = result
        return false
      },
      set (value) {
        let self = this
        if (value) {
          self.editedFilter.tripDirection = ['all', 'p2p', 'in', 'out']
        } else {
          self.editedFilter.tripDirection = []
        }
      }
    },
    checkedAllRsvpStatus: {
      get () {
        let self = this
        if (self.editedFilter === null) {
          return false
        }
        if (self.editedFilter.rsvpStatus.length === 13) {
          return true
        }

        let result = []
        for (let i = 0; i < self.editedFilter.rsvpStatus.length; i++) {
          let item = self.editedFilter.rsvpStatus[i]
          if (item === 'all') {
            continue
          }
          result.push(item)
        }
        console.log('TEST', result)
        self.editedFilter.rsvpStatus = result
        return false
      },
      set (value) {
        let self = this
        if (value) {
          self.editedFilter.rsvpStatus = [
            'all', 'upcoming', 'auto-dispatch', 'ready', 'require-dispatch',
            'driver-response', 'dispatched', 'onboard', 'completed',
            'cancelled', 'packaged', 'un-packaged', 'none'
            ]
        } else {
          self.editedFilter.rsvpStatus = []
        }
      }
    }
  },
  methods: {
    init () {
      let self = this
      self.initGeofences()
      if (self.filterId === 'new') {
        self.filter = {  
           name: '',
           beforePickupMins: 0,
           afterPickupMins: 0,
           tripDirection:[],
           rsvpStatus:[],
           geofenceIds:[],
           stagingLotIds:[],
           ada:[],
           defaultPickupAddress: '',
           defaultPickupType: 'address',
           defaultGeofenceId: null,
           bidSource:[],
           serviceTypes:[],
           packageStatus:null
        }
        self.editedFilter = {  
           name: '',
           beforePickupMins: 0,
           afterPickupMins: 0,
           tripDirection:[],
           rsvpStatus:[],
           geofenceIds:[],
           stagingLotIds:[],
           ada:[],
           defaultPickupAddress: '',
           defaultPickupType: 'address',
           defaultGeofenceId: null,
           bidSource:[],
           serviceTypes:[],
           packageStatus:null
        }
        return
      }

      self.fetchingFilter = true

      self.$sdk.get('/admin/filters/' + self.filterId, {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.fetchingFilter = false
        console.log('FILTER', r)
        if (r.error) {
          // TODO: show error message
          return
        }

        self.filter = r
        self.editedFilter = Object.assign({}, r)
      })
    },
    initGeofences () {
      let self = this
      self.$sdk.get('/geofences', {}, r => {
        console.log('GEOFENCES', r)
        if (r.error || r.list.length <= 0) {
          return
        }
        self.serviceAreas = []
        let serviceAreas = r.list.filter(x => x.type === 'servicearea')
        serviceAreas.forEach(function (data) {
          self.serviceAreas.push({
            brand: '',
            id: data.id,
            name: data.name
          })
        })

        self.stagingLots = []
        let stagingLots = r.list.filter(x => x.type === 'staging')
        stagingLots.forEach(function (data) {
          self.stagingLots.push({
            id: data.id,
            name: data.name
          })
        })

        let request = {
          token: self.$store.state.session.sessionToken,
          status: 'active',
          pageNum: 1,
          pageSize: 9999,
          order: 'priority',
          brandId: -2
        }
        self.$sdk.get('/servicearea', request, r2 => {
          r2.list.forEach(function (data) {
            if (data.brandId) {
              self.serviceAreas.push({
                brand: data.brandId,
                id: data.id,
                name: data.name
              })
            }
          })
        }, '2.0')
      })
    },
    getServiceTypes () {
      let serviceId = CONFIG.serviceId
      let result = []

      for (let prop in serviceId) {
        if (!serviceId.hasOwnProperty(prop)) {
          return
        }

        let serviceName = prop.charAt(0).toUpperCase() + prop.slice(1)
        if (prop === 'shared') {
          serviceName = 'Shared Ride'
        } else if (prop === 'opoli') {
          serviceName = 'Direct Non-Stop'
        } else if (prop === 'black') {
          serviceName = 'Sedan'
        } else if (prop === 'suv') {
          serviceName = 'SUV'
        } else {
          serviceName = 'Private Van'
        }
        result.push({
          name: serviceName,
          id: serviceId[prop]
        })
      }
      return result
    },
    serviceList (brandId) {
      let serviceList = this.$store.state.services.list.filter(x => x.brandId === brandId && x.enabled)
      return serviceList
    },
    unbrandedServicearea () { return this.serviceAreas.filter(x => x.brand === '') },
    brandedServicearea (brandId) { return this.serviceAreas.filter(x => x.brand === brandId) },
    save () {
      let self = this
      self.formErrors = {
        name: false,
        beforePickupMins: false,
        afterPickupMins: false,
        tripDirection: false,
        rsvpStatus: false,
        bidSource: false,
        serviceTypes: false,
        ada: false,
        serviceAreas: false
      }
      if (self.editedFilter.name === '') {
        self.formErrors.name = true
        return
      }
      if (self.editedFilter.beforePickupMins <= 0) {
        self.formErrors.beforePickupMins = true
        return
      }
      if (self.editedFilter.afterPickupMins <= 0) {
        self.formErrors.afterPickupMins = true
        return
      }
      if (self.editedFilter.tripDirection.length <= 0) {
        self.formErrors.tripDirection = true
        return
      }
      if (self.editedFilter.rsvpStatus.length <= 0) {
        self.formErrors.rsvpStatus = true
        return
      }
      if (self.editedFilter.bidSource.length <= 0) {
        self.formErrors.bidSource = true
        return
      }
      if (self.editedFilter.serviceTypes.length <= 0) {
        self.formErrors.serviceTypes = true
        return
      }
      if (self.editedFilter.ada.length <= 0) {
        self.formErrors.ada = true
        return
      }
      if (self.editedFilter.geofenceIds.length <= 0) {
        self.formErrors.serviceAreas = true
        return
      }

      self.savingFilter = true

      let request = self.editedFilter
      request['token'] = self.$store.state.session.sessionToken
      if (self.filterId === 'new') {
        self.$sdk.post('/admin/filters', request, r => {
          console.log('NEW', r)
          if (r.error) {
            return
          }
          self.$router.push({name: 'Filters'})
        })
        return
      }

      self.$sdk.post('/admin/filters/' + self.filterId, request, r => {
        console.log('EDIT', r)
        if (r.error) {
          return
        }
        window.location.reload()
      })
    }
  },
  watch: {
    filterId: function (value) { 
      this.init() 
    }
  },
  mounted () {
    let self = this
    self.init()

    if (!self.$store.state.brands.list.length) {
      self.brandLoading = true
      ApiBrands.getBrands(self, function (res) {
        self.brandLoading = false
      })
    }

    if (!self.$store.state.services.list.length) {
      self.$store.commit('services/setServiceLoading', true)
      ApiServices.getAllService(self, r => {
        self.$store.commit('services/setServiceLoading', false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  font-weight: 700;
  font-size: 22px;
  color: #3F2975;
  background-color: #fff;
  display: block;
  line-height: 22px;
  padding: 14px 0 14px 64px;
  border-bottom: 1px solid rgba(0,0,0,0.15);
}
.filter-inputs {
  margin: 30px 0;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  padding: 15px;
}

.field-group-label {
  font-size: 12px;
  font-weight: 700;
  color: #0D79F2;
}

.input-field {
  & > label {
    font-size: 12px;
    font-weight: 700;
    color: #0D79F2;
  }

  & > input {
    margin-top: 5px;
    padding: 10px;
    font-size: 14px;
    background-color: #fff;
  }

  & .error-msg {
    font-size: 10px;
    font-weight: 700;
    color: #F20D0D;
    margin-top: 3px;
    display: none;
  }

  &.error {
    & > input { border-color: #F20D0D; }
    & > .error-msg { display: block; }
  }
}

.input-checkbox {
  display: block;
  font-size: 14px;

  & > * {
    display: inline-block;
    vertical-align: middle;
  }

  & > input {
    width: auto;
    margin-top: 0;
    margin-right: 5px;
  }
}

.input-address {
  display: block;
  margin-top: 10px;

  & > * {
    display: inline-block;
    vertical-align: middle;
  }

  & input[type="text"],
  & select {
    margin-top: 0;
    width: 290px;
    font-size: 14px;
    outline: 0;
    padding: 10px;

    &.disabled{
      color: rgba(0,0,0,0.3);
      background-color: #eee;
    }
  }

  & select {
    font-size: 14px;
    height: 43px;
    outline: 0;
    padding: 10px;
    display: inline-block;
    width: 290px;
    border-color: rgba(0,0,0,0.15);
    background-color: #fff;
    border-radius: 3px;
  }

  & input[type="radio"] {
    margin-top: 0;
    margin-right: 5px;
    width: auto;
  }
}

.field-group {
  & .error-msg {
    font-size: 10px;
    font-weight: 700;
    color: #F20D0D;
    margin-top: 3px;
    display: none;
  }

  &.error {
    //background-color: rgba(242, 13, 13, 0.3);
    & > input { border-color: #F20D0D; }
    & > .error-msg { display: block; }
  }
}
.controls {
  text-align: center;
  border-top: 1px solid rgba(0,0,0,0.15);
  padding: 20px 0 5px;
  margin-top: 10px;
}

.services{
  margin-bottom: 10px;

  .brand{
    display: block;
    font-weight: 600;
  }

  ul{
    padding: 0;
    margin: 0;
    list-style: none;
    -webkit-column-count: 3;
    -moz-column-count: 3;
    column-count: 3;
    column-gap: 5px;

    li{
      font-size: 14px;

      input{
        display: inline;
        width: inherit;
        vertical-align: -2px;
        margin: 0 5px 0 0;
      }
    }
  }
}

.servicearea-list{
  margin-bottom: 10px;

  .label{
    font-weight: 600;
  }
}

.margin-T{ margin-top: 15px; }
.padding-L{ padding-left: 7px; }
.padding-R{ padding-right: 7px; }

@media only screen and (max-width: 430px) {
  .input-checkbox {
    font-size: 13px;
    display: flex;
    gap: 5px;
    align-items: center;
    margin-bottom: 8px;
  }
  .small-6, .small-9 {
    width: 100%;
  }
  .small-6 {
    margin-bottom: 10px;
  }

  .small-3, .small-4 {
    width: 50%;
    padding-left: 0;
  }

  .padding-L {
    padding-left: 0;
  }

  .services ul {
    column-count: 2;
    li {
      font-size: 13px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Filters/FilterDetails.vue